import Pagination from '@molecules/Pagination'
import { type SupporterShowType } from '@frontend/contexts/supporters-management/types/supporterTypes'
import EmptyState from '@components/molecules/EmptyState'
import { scopedTranslation } from '@utils/I18n'

import ContactLogCard from './ContactLogCard'

const t = scopedTranslation('components.contacts_log')

type ContactsLogProps = {
  contacts: SupporterShowType['contacts']['nodes']
  totalPages: number
}

export default function ContactsLog({ contacts, totalPages }: ContactsLogProps) {
  if (contacts.length === 0) {
    return (
      <div data-testid="contacts-log">
        <EmptyState iconType="search-lg" headline={t('empty_state.title')} subtext={t('empty_state.description')} />
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-2" data-testid="contacts-log">
      <div className="tw:shadow-xs tw:rounded-xl tw:border tw:border-gray-200 tw:*:border-b tw:*:border-gray-200 tw:[&>*:last-child]:border-b-0">
        {contacts.map((contact) => (
          <ContactLogCard key={contact.id} {...contact} />
        ))}
      </div>
      <Pagination totalPages={totalPages} only={['contacts']} />
    </div>
  )
}
